var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4668 14.8H16.2401V18.44H24.9201C24.4801 23.52 20.2535 25.6933 16.2535 25.6933C11.1468 25.6933 6.66679 21.6667 6.66679 16C6.66679 10.5333 10.9335 6.30666 16.2668 6.30666C20.3868 6.30666 22.8001 8.93333 22.8001 8.93333L25.3335 6.29333C25.3335 6.29333 22.0801 2.66666 16.1335 2.66666C8.56012 2.66666 2.70679 9.06666 2.70679 16C2.70679 22.7333 8.21345 29.3333 16.3335 29.3333C23.4668 29.3333 28.6668 24.44 28.6668 17.2133C28.6668 15.68 28.4668 14.8 28.4668 14.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon_google.dcc3dce3e3a9c00fa9ccc854af1bdacf.svg";
export { ForwardRef as ReactComponent };